import React, { useState } from "react"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody, Button, Table, Input } from "reactstrap"
import { useNavigate } from "react-router-dom"
import { FaEdit, FaPlus } from "react-icons/fa"
import { MdDelete } from "react-icons/md"

const ColdCallingIndex = () => {
  const navigate = useNavigate()

  const [data] = useState([
    { id: 1, name: "John Smith", email: "john@gmail.com", country: "USA" },
    { id: 2, name: "Amit Patel", email: "amit@gmail.com", country: "India" },
  ])

  const handleDelete = () => {
    
  }

  return (
    <div className="page-content">
      <Breadcrumb
        title="Cold Calling Management"
        breadcrumbItem="Cold Calling"
      />

      <Card>
        <CardBody>
          {/* Top Bar */}
          <div className="d-flex justify-content-between mb-3">
            <Input
              placeholder="Search name, email, country..."
              style={{ width: 300 }}
              className="rounded-4"
            />

            <Button
              className="btn-blue rounded-4"
              onClick={() => navigate("/cold-calling/add")}
            >
              <FaPlus className="me-1" /> Add Contact
            </Button>
          </div>

          {/* Table */}
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Email</th>
                <th>Country</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.country}</td>
                  <td>
                    <Button
                      color="info"
                      onClick={() => navigate(`/cold-calling/edit/${item.id}`)}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      color="danger"
                      className="ms-3"
                      onClick={() => handleDelete()}
                    >
                      <MdDelete />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </div>
  )
}

export default ColdCallingIndex
